import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQuestionCircle,
  faChevronLeft,
  faRedo,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from '../../navigation';
import {
  ChevronLeftIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/20/solid';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  onClick?: () => void;
  show_refresh?: boolean;
  show_help?: boolean;
  hide?: boolean;
  hide_back?: boolean;
  middle_option?;
  help_element?: React.ReactNode;
};

const NavBar: React.FC<Props> = ({
  onClick = null,
  show_refresh = false,
  show_help = true,
  hide = false,
  hide_back = false,
  middle_option,
  help_element,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="px-4 bg-background md:px-0 pb-2 pt-2 space-x-10 justify-between flex flex-row items-center md:px-8 lg:px-16 xl:px-32">
        <button
          className={` bg-background flex  justify-right items-center rounded-full w-1/5 h-8 outline-none focus:outline-none ${
            hide_back && 'hidden'
          }`}
          onClick={
            onClick !== null
              ? onClick
              : () => {
                  navigate(-1);
                }
          }
        >
          <ChevronLeftIcon className="w-6 h-6 text-primary" />
        </button>

        {show_refresh && (
          <button
            className={`bg-background  flex  justify-end items-center rounded-full w-1/5 h-8 outline-none focus:outline-none`}
            onClick={() => {
              window.location.reload();
            }}
          >
            <FontAwesomeIcon icon={faRedo as IconProp} />
          </button>
        )}
        {middle_option && middle_option}

        {show_help && (
          <div className="bg-background flex  justify-right items-center rounded-full w-1/5 h-8 outline-none focus:outline-none"></div>
        )}
        {!show_help && help_element && help_element}
      </div>
    </>
  );
};

export default NavBar;
